import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { getItem } from "@purple-dot/browser-sdk/src/libraries/local-storage";
function isInternalUser() {
    var internalUser = getItem("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
}
function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return global.navigator.userAgent.match(BOTS);
}
var FilterWrapper = {
    track: function(event, properties) {
        if (!(isInternalUser() || isKnownBot())) {
            var ref;
            (ref = window.FS) === null || ref === void 0 ? void 0 : ref.call(window, "trackEvent", {
                name: event,
                properties: properties
            });
        } else {
            // biome-ignore lint/suspicious/noConsole: debug
            console.log("INTERNAL USER - Track: ", event, properties);
        }
    }
};
var Analytics = _object_spread_props(_object_spread({}, FilterWrapper), {
    trackProductViewed: function(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderCreated: function(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackLastSeenProductClicked: function() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackUserProgressed: function(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    }
});
export default Analytics;
